import useColors from 'hooks/useColors';
import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import { rem } from './values';
import { isWeb } from '../constants';
const FlatListItemCard = ({ children, index, itemsLength, style, onPress, }) => {
    const colors = useColors();
    const borderStyles = [
        index === 0 && styles.bordersFirst,
        index === (itemsLength || 0) - 1 && styles.bordersLast,
        index === 0 &&
            itemsLength !== undefined &&
            itemsLength === 0 &&
            styles.bordersSolo,
        styles.borderColor,
    ];
    const containerStyles = [
        styles.itemContainer,
        index === 0 && styles.itemContainerFirst,
        index === (itemsLength || 0) - 1 && styles.itemContainerLast,
    ];
    if (onPress) {
        return (<View style={[borderStyles, containerStyles, style]}>
        <TouchableHighlight onCard hoverOnLight onPress={onPress} activeOpacity={1} disabled={!onPress} style={borderStyles} underlayColor={colors.background.underlay}>
          {children}
        </TouchableHighlight>
      </View>);
    }
    return <View style={[borderStyles, containerStyles, style]}>{children}</View>;
};
const radius = isWeb ? rem(10) : rem(16);
const styles = StyleSheet.create({
    borderColor: {
        borderColor: 'transparent',
    },
    itemContainer: {
        marginHorizontal: rem(16),
        ...(isWeb && {
            paddingHorizontal: rem(8),
        }),
    },
    itemContainerFirst: {
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
        ...(isWeb && {
            paddingTop: rem(8),
        }),
    },
    itemContainerLast: {
        borderBottomLeftRadius: rem(16),
        borderBottomRightRadius: rem(16),
        ...(isWeb && {
            paddingBottom: rem(8),
        }),
    },
    bordersSolo: {
        borderRadius: rem(16),
        ...(Platform.OS === 'ios' && {
            overflow: 'hidden',
        }),
    },
    bordersFirst: {
        borderTopLeftRadius: radius,
        borderTopRightRadius: radius,
        ...(Platform.OS === 'ios' && {
            overflow: 'hidden',
        }),
    },
    bordersLast: {
        borderBottomLeftRadius: radius,
        borderBottomRightRadius: radius,
        ...(Platform.OS === 'ios' && {
            overflow: 'hidden',
        }),
    },
});
export default FlatListItemCard;
